<template>
    <div class="app-block">
        <div class="app-block__wrapper">
            <slot></slot>
        </div>
    </div>
</template>

<script lang="ts" setup>
</script>

<style lang="less">
@import './index.less';
</style>